import { DataVersion, NeighboringAlarmsDTO } from '@hakimo-ui/hakimo/types';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { withDataVersion } from '@hakimo-ui/hakimo/util';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';
dayjs.extend(utc);

export function useNeighboringAlarms(
  id: string,
  searchParams: string,
  refetchInterval: number,
  timestamp: string,
  dataVersion?: DataVersion
) {
  const date = dayjs.utc(timestamp);
  const partitionKey = date.format('YYYYMM');
  const url = `/v2/orm/alarm/neighbors/${id}?${searchParams}&partitionKey=${partitionKey}`;
  const request = new Request(url);
  withDataVersion(request, dataVersion);

  return useAuthenticatedRequest<NeighboringAlarmsDTO>(request, {
    queryKey: ['alarm-neighbors', id, { searchParams, dataVersion }],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    refetchInterval,
  });
}

export default useNeighboringAlarms;
